import { IconName } from '@thiememeulenhoff/types';
import { PaletteColor, ThemeColor, Tint } from '@thiememeulenhoff/tokens';

export const AlertTypes = [
  'info',
  'success',
  'danger',
  'error',
  'warning',
  'neutral',
] as const;
export type AlertType = (typeof AlertTypes)[number];

export const alertIcons: Record<AlertType, IconName> = {
  info: 'info-solid',
  success: 'success-solid',
  danger: 'danger-solid',
  error: 'error-solid',
  warning: 'warning-duo',
  neutral: 'user',
};

export const alertColors: Record<AlertType, PaletteColor | ThemeColor> = {
  info: 'blue',
  success: 'green',
  danger: 'red',
  error: 'red',
  warning: 'orange',
  neutral: 'grey',
};

export const alertTints: Record<AlertType, Tint> = {
  info: 500,
  success: 500,
  danger: 600,
  error: 600,
  warning: 500,
  neutral: 700,
};

export const AlertVariants = ['default', 'inline'] as const;

export type AlertVariant = (typeof AlertVariants)[number];
